import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/Welcome.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/') {
          console.log("ROUTE GUARD..." + to.fullPath)
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/quiz',
      name: 'quiz',
      component: () => import(/* webpackChunkName: "users" */ './views/Quiz.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/quiz') {
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "public" */ './views/Login.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/login') {
          if (store.state.token) {
            next('/welcome');
            return
          }
          next()
        }
      }
    },
    {
      path: '/forgot-password',
      name: 'forgotpassword',
      component: () => import(/* webpackChunkName: "public" */ './views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'resetpassword',
      component: () => import(/* webpackChunkName: "public" */ './views/ResetPassword.vue')
    },
    // {
    //   path: '/signin',
    //   name: 'signin',
    //   component: () => import(/* webpackChunkName: "public" */ './views/Signin.vue')
    // },
    {
      path: '/logout',
      name: 'logout',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/Logout.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/logout') {
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import(/* webpackChunkName: "public" */ './views/Register.vue')
    },
    {
      path: '/history',
      name: 'history',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/History.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/history') {
          console.log("ROUTE GUARD..." + to.fullPath)
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/profile',
      name: 'profile',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/Profile.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/profile') {
          console.log("ROUTE GUARD..."+to.fullPath)
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/smart_parking',
      name: 'smart_parking',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/SmartParking.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/smart_parking') {
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    {
      path: '/leocubs',
      name: 'leocubs',
      meta: { layout: "default" },
      component: () => import(/* webpackChunkName: "users" */ './views/LeoCubs.vue'),
      beforeEnter: (to, from, next) => {
        if (to.fullPath === '/leocubs') {
          if (!store.state.token) {
            next('/login');
            return
          }
          next()
        }
      }
    },
    { path: '*', redirect: '/' }
  ],
});

// router.beforeEach((to, from, next) => {
//   store.dispatch('fetchAccessToken');
//   if (to.fullPath === '/users') {
//     if (!store.state.accessToken) {
//       next('/login');
//     }
//   }
//   if (to.fullPath === '/login') {
//     if (store.state.accessToken) {
//       next('/users');
//     }
//   }
//   next();
// });

export default router